import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuItem: { title: "首页", path: "/index" },
    productsIndex: 0,
    solutionsIndex: 0,
    caseSuccsIndex: 0,
    caseActive: 0,
    newsActive: 0,
    newsCurrentPage: 1
  },
  mutations: {
    updateNewsClick: function(state, status) {
      state.newsActive = status.active;
      state.newsCurrentPage = status.currentPage;
    },
    updateMenuItem: function(state, status) {
      state.menuItem = status;
    },
    updateProductsIndex: function(state, status) {
      state.productsIndex = status;
    },
    updateSolutionsIndex: function(state, status) {
      state.solutionsIndex = status;
    },
    updateCaseSuccsIndex: function(state, status) {
      state.caseSuccsIndex = status;
    },
    updateCaseActive: function(state, status) {
      state.caseActive = status;
    }
  },
  actions: {},
  modules: {}
});
